import type { Infer } from 'superstruct';
import {
	array,
	nullable,
	number,
	object,
	optional,
	partial,
	string,
} from 'superstruct';

import {
	parsableInteger,
	stringDate,
	userString,
} from '@adflow/shared/util-superstruct';

import {
	AddFacebookAdCreativeTemplateDto,
	ViewFacebookAdCreativeTemplateDto,
} from './facebook-adcreative-template.dto';

export const AddFacebookAdTemplateDto = object({
	id: optional(parsableInteger()),
	name: userString('validations:Required'),
	adType: userString('validations:Required'),
	adStatus: userString('validations:Required'),

	adCreativeTemplates: optional(array(AddFacebookAdCreativeTemplateDto)),
});

export const ViewFacebookAdTemplateDto = object({
	id: number(),
	name: string(),
	adType: string(),
	adStatus: string(),

	adCreativeTemplates: optional(array(ViewFacebookAdCreativeTemplateDto)),

	ads: optional(
		array(
			object({
				id: number(),
				facebookId: string(),
				syncedAt: stringDate(),
				adTemplateId: nullable(number()),
				adCreativeTemplateId: number(),
				adSetTemplateId: number(),
			})
		)
	),
});

export type ViewFacebookAdTemplateDto = Infer<typeof ViewFacebookAdTemplateDto>;
export type AddFacebookAdTemplateDto = Infer<typeof AddFacebookAdTemplateDto>;
export const EditFacebookAdTemplateDto = partial(AddFacebookAdTemplateDto);
export type EditFacebookAdTemplateDto = Infer<typeof EditFacebookAdTemplateDto>;
